<script setup lang="ts"></script>

<template>
  <div class="app-container d-flex h-100">
    <router-view></router-view>
  </div>
</template>
